import ReferenceDataTab from "@features/security/components/ReferenceDataTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Database } from "lucide-react";

export const Route = createFileRoute("/_app/admin/reference-data/")({
  loader: requirePermission(PERMISSIONS.SECURITY.PERMISSIONS.VIEW),
  staticData: {
    title: "Catalogue permissions",
    icon: Database,
    tab_icon: Database,
    permission: PERMISSIONS.SECURITY.PERMISSIONS.VIEW,
    module: "security",
    section: "Administration",
    order: 40,
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
    description: "Catalogue des permissions",
  },
  component: ReferenceDataTab,
});
